import React from 'react';
import '../styles/App.css';
import Sidebar from '../components/sidemenu/sidebar';
import CrudTable from '../components/cruds/crud_USERS';

const admUsers = () => {
  return (
    <div>
        <Sidebar/>
        <div>
            <h3 className="title"> Administración Usuarios</h3>
        </div>
        <CrudTable/>
    </div>
  );


};

export default admUsers;